import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const fetchTotalCountsAction = async () => {
  try {
    const response = await apiClient.get(ATP_API_URL.TOTAL_COUNTS);

    if (response?.status === 200 && response.data?.success) {
      return {
        success: true,
        data: {
          totalServicePartner: response.data.totalServicePartner || 0,
          totalClients: response.data.totalClients || 0,
          totalPendings: response.data.totalPendings || 0,
        },
        message: response.data.message,
      };
    }

    return {
      success: false,
      data: {
        totalServicePartner: 0,
        totalClients: 0,
        totalPendings: 0,
      },
      message: "Failed to fetch counts",
    };
  } catch (error) {
    return {
      success: false,
      data: {
        totalServicePartner: 0,
        totalClients: 0,
        totalPendings: 0,
      },
      message: error.message || "Failed to fetch counts",
      error,
    };
  }
};
